import React from "react";

import { GoogleAuthConsumer } from "./GoogleAuthContext";

const GoogleUserContext = React.createContext();
export const GoogleUserConsumer = GoogleUserContext.Consumer;

/**
 * Context Provider for `Google.auth().currentUser`, available only after Google
 * has initalized, so you'll usually want to nest this inside <GoogleAuthInitalizer>.
 */
export class GoogleUserProvider extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const throwError = () => {
            throw new Error("Cannot render GoogleUserProvider before GoogleAuthProvider has initalized");
        };

        const { children } = this.props;
        return (
            <GoogleAuthConsumer>
                {auth => (
                    auth
                        ? (
                            <GoogleUserContext.Provider value={auth.currentUser}>
                                {children}
                            </GoogleUserContext.Provider>
                        )
                        : throwError()
                )}
            </GoogleAuthConsumer>
        );
    }
}

/**
 * HOC that injects Google `googleUser` prop.
 */
export function withGoogleUser(Component) {
    return function WithGoogleUser(props) {
        return (
            <GoogleUserContext.Consumer>
                {user => {
                    if (user === undefined) {
                        throw new Error("WithGoogleUser can't be rendered before GoogleAuthProvider has initalized");
                    }
                    return <Component {...props} googleUser={user} />;
                }}
            </GoogleUserContext.Consumer>
        );
    };
}
